import { Component, OnInit, Input } from '@angular/core';
import { ProfileAdvancedSearchParams } from '../profile-advanced-search-params.model';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { FieldTypeEnum } from '../../../shared/search-expression/field-type.enum';
import { DatePeriodEnum } from '../../../shared/search-expression/date-period.enum';
import { TranslationService } from '../../../shared/translation/translation.service';
import { RevenueItemService } from '../../../revenue/shared/revenue-items/revenue-item.service';
import { MemberActivityTypeModel } from '../../../member/shared/member-activity-type.model';
import { MemberService } from '../../../member/shared/member.service';
import { ListingCategoryService } from '../../../listing-catagories/listing-category.service';
import { ListingCategorySearchResult } from '../../../listing-catagories/listing-category-search-result.model';
import { ListingCategorySearchParams } from '../../../listing-catagories/listing-category-search-params.model';
import { ListingCategory } from '../../../listing-catagories/listing-category.model';
import { ListingSubCategoryService } from '../../../listing-catagories/listing-sub-category.service';
import { ListingSubCategorySearchResult } from '../../../listing-catagories/listing-sub-category-search-result.model';
import { ListingSubCategorySearchParams } from '../../../listing-catagories/listing-sub-category-search-params.model';
import { ListingSubCategory } from '../../../listing-catagories/listing-sub-category.model';
import { RelationTypeService } from '../../shared/relation-type.service';
import { RelationTypeSearchParams } from '../../shared/relation-type-search-params.model';
import { Office, OfficeSearch, Official, OfficialSearch, VoterVoiceService } from '../../../integrations/voter-voice/shared/index';
import { DataViewService } from '../../shared/data-view.service';
import { DataViewMin } from '../../shared/data-view-min.model';
import { NahbMemberType } from '../../../vertical/nahb/shared/nahb-member-type.model';
import { VerticalNahbService } from '../../../vertical/nahb/shared/vertical-nahb.service';
import { VerticalNaaService } from '../../../vertical/naa/shared/vertical-naa.service';

@Component({
  selector: 'wl-profile-search-summary',
  templateUrl: 'profile-search-summary.component.html',
  providers: [
    TranslationService,
    RevenueItemService,
    MemberService,
    ListingSubCategoryService,
    RelationTypeService,
    VoterVoiceService,
    DataViewService,
    VerticalNaaService,
    VerticalNahbService,
  ],
    standalone: false
})
export class ProfileSearchSummaryComponent implements OnInit {
  @Input() searchParams: ProfileAdvancedSearchParams;
  public billingMonth: string;
  public revenueItemDescription: string;
  public memberActivityNames: Array<string>;
  public hiddenAffCodeCount: number;
  public affCodeTooltip: string;
  @Input() summaryVisible: boolean;
  public allAffCodeVisible: boolean;
  public allMemberTypeVisible: boolean;
  public allBusinessActvitiesVisible: boolean;
  public allNaaProfileTypesVisible: boolean;
  public paramCount: number;
  public categoryNames: Array<string>;
  public relationshipName: string;
  public voterVoiceOfficeNames: Array<string>;
  public voterVoiceOfficialNames: Array<string>;
  public dataViewDescr: string;
  public dataViewSqlText: string;
  public nahbMemberTypes: Array<NahbMemberType>;
  public nahbMemberTypeNames: Array<string>;
  public nahbBusinessActivityNames: Array<string>;
  public naaProfileTypeNames: Array<string>;
  public showRelatedProfileSummary: boolean;
  public datePeriodEnum: object = DatePeriodEnum;

  public constructor(
    private _dataViewService: DataViewService,
    private _listingCategorySearchService: ListingCategoryService,
    private _listingSubCategorySearchService: ListingSubCategoryService,
    private _memberService: MemberService,
    private _relationTypeService: RelationTypeService,
    private _verticalNahbService: VerticalNahbService,
    private _revenueItemService: RevenueItemService,
    private _translationService: TranslationService,
    private _verticalNaaService: VerticalNaaService,
    private _voterVoiceService: VoterVoiceService
  ) {
    this.allAffCodeVisible = false;
    this.allMemberTypeVisible = false;
    this.allBusinessActvitiesVisible = false;
    this.allNaaProfileTypesVisible = false;
    this.paramCount = 0;
    this.categoryNames = new Array<string>();
    this.memberActivityNames = new Array<string>();
    this.voterVoiceOfficeNames = new Array<string>();
    this.voterVoiceOfficialNames = new Array<string>();
    this.nahbMemberTypeNames = new Array<string>();
    this.nahbBusinessActivityNames = new Array<string>();
    this.naaProfileTypeNames = new Array<string>();
    this.dataViewDescr = '';
    this.nahbMemberTypes = new Array<NahbMemberType>();
    this.showRelatedProfileSummary = false;
  }

  ngOnInit() {
    this.refresh();
    this.refreshHeader();
  }

  public toggleSummaryVisible() {
    this.summaryVisible = !this.summaryVisible;
    if (this.summaryVisible) this.refresh();
  }

  public hideSummary() {
    this.summaryVisible = false;
  }

  public refreshHeader() {
    this.paramCount = 0;
    if (this.searchParams.Keyword) this.paramCount++;
    if (
      this.searchParams.BillingAnchorMonth > 0 ||
      this.searchParams.BillingRevenueItemNum > 0 ||
      this.searchParams.DuesAmountMin > 0 ||
      this.searchParams.DuesAmountMax > 0
    )
      this.paramCount++;
    if (this.searchParams.CommonDataView.length) this.paramCount++;
    if (this.searchParams.DataViewId > 0) this.paramCount++;
    if (this.searchParams.SqlWhereClause) this.paramCount++;
    this.paramCount += this.searchParams.CategorySearchExpressions.length;
    this.paramCount += this.searchParams.ContactInfoSearchExpressions.length;
    this.paramCount += this.searchParams.EventsSearchExpressions.length;
    this.paramCount += this.searchParams.MemberActivitySearchExpressions.length;
    this.paramCount += this.searchParams.VoterVoicehExpressions.length;
    this.paramCount += this.searchParams.AffCodes.length;
    this.paramCount += this.searchParams.ExcludeAffCodes.length;
    this.paramCount += this.searchParams.NaaProfileTypes.length;
    this.paramCount += this.searchParams.NahbMemberTypes.length;
  }

  public refresh() {
    let categoryParams = new ListingCategorySearchParams();
    let subCategoryParams = new ListingSubCategorySearchParams();
    let categoryResults = new Array<ListingCategory>();
    let subCategoryResults = new Array<ListingSubCategory>();
    categoryParams.PageNumber = 0;
    categoryParams.PageSize = 0;
    subCategoryParams.PageNumber = 0;
    subCategoryParams.PageSize = 0;
    if (this.searchParams.DataViewId > 0) {
      this._dataViewService.getSavedDataView(this.searchParams.DataViewId).then((data) => {
        this.dataViewDescr = data.Descr;
        // just showing the name right now. maybe do this in the future
        //if (data.Version == 2)
        //    this.searchParams = JSON.parse(data.SearchParams);
        //else if (data.SQLText)
        //    this.dataViewSqlText = data.SQLText;
      });
    }
    this.billingMonth = this._translationService.getMonthName(this.searchParams.BillingAnchorMonth - 1);
    if (this.searchParams && this.searchParams.BillingRevenueItemNum)
      this._revenueItemService.getRevenueItem(this.searchParams.BillingRevenueItemNum).then((data) => {
        this.revenueItemDescription = data.Descr;
      });
    if (this.searchParams && this.searchParams.MemberActivitySearchExpressions.length && !this.memberActivityNames.length)
      this._memberService.getMemberActivityTypes().then((results) => {
        results.forEach((x) => (this.memberActivityNames[x.ActivityTypeID] = x.ActivityType));
      });
    if (this.searchParams && this.searchParams.CategorySearchExpressions.length && !this.categoryNames.length) {
      Promise.all([
        this._listingCategorySearchService.search(categoryParams).then((data) => {
          categoryResults = data.Result;
        }),
        this._listingSubCategorySearchService.search(subCategoryParams).then((data) => {
          subCategoryResults = data.Result;
        }),
      ]).then(() => {
        subCategoryResults = subCategoryResults.sort((a, b) => {
          if (a.SubCategory > b.SubCategory) return 1;
          if (a.SubCategory < b.SubCategory) return -1;
          return 0;
        });
        categoryResults.forEach((x) => {
          this.categoryNames['Id' + x.CategoryID.toString()] = x.Category;
          subCategoryResults
            .filter((y) => {
              return x.CategoryID == y.CategoryID;
            })
            .forEach((y) => {
              this.categoryNames['Id' + x.CategoryID.toString() + '\\' + y.SubCategoryID.toString()] = x.Category + '\\' + y.SubCategory;
            });
        });
      });
    }
    if (this.searchParams && this.searchParams.RelatedProfileOptions.UseRelatedAs && this.searchParams.RelatedProfileOptions.RelatedAs) {
      this._relationTypeService.getRelationshipType(this.searchParams.RelatedProfileOptions.RelatedAs).then((data) => {
        if (data) this.relationshipName = data.RelationType;
        else this.relationshipName = '';
      });
    }
    if (
      this.searchParams &&
      this.searchParams.VoterVoicehExpressions &&
      this.searchParams.VoterVoicehExpressions.length &&
      this.voterVoiceOfficeNames &&
      this.voterVoiceOfficeNames.length == 0 &&
      this.voterVoiceOfficialNames.length == 0
    ) {
      let officeSearchParams: OfficeSearch = new OfficeSearch();
      let officialSearchParams: OfficeSearch = new OfficialSearch();

      officeSearchParams.PageNumber = officeSearchParams.PageSize = officialSearchParams.PageNumber = officialSearchParams.PageSize = 0;

      // make api calls
      let officePromise: Promise<PagedResult<Office[]>> = this._voterVoiceService.searchOffices(officeSearchParams);
      let officialPromise: Promise<PagedResult<Official[]>> = this._voterVoiceService.searchOfficials(officialSearchParams);

      // wait
      Promise.all([officePromise, officialPromise]).then(([officesResult, officialsResult]) => {
        // get offices result
        if (officesResult && officesResult.Result) {
          officesResult.Result.forEach((x) => {
            this.voterVoiceOfficeNames['Id' + x.OfficeUniqueId.toString()] = x.electedBody + ' ' + x.electoralDistrict;
          });
        }

        // get officials result
        if (officialsResult && officialsResult.Result)
          officialsResult.Result.forEach((x) => {
            this.voterVoiceOfficialNames['Id' + x.OfficialUniqueId.toString()] = x.displayName;
          });
      });
    }

    if (this.searchParams && this.searchParams.NahbMemberTypes.length > 0 && this.nahbMemberTypeNames.length == 0) {
      this._verticalNahbService.getHbaMemberTypes().then((data) => {
        data.forEach((x) => {
          this.nahbMemberTypeNames['Id' + x.Code.toString()] = x.Descr;
        });
      });
    }

    if (this.searchParams && this.searchParams.NahbBusinessActivities.length > 0 && this.nahbBusinessActivityNames.length == 0) {
      this._verticalNahbService.getHbaBusinessActivityTypes().then((data) => {
        data.forEach((x) => {
          this.nahbBusinessActivityNames['Id' + x.Code.toString()] = x.Descr;
        });
      });
    }

    if (
      this.searchParams &&
      this.searchParams.NaaProfileTypes &&
      this.searchParams.NaaProfileTypes.length > 0 &&
      this.naaProfileTypeNames &&
      this.naaProfileTypeNames.length == 0
    ) {
      this._verticalNaaService.getNaaProfileTypes().then((data) => {
        data.forEach((x) => {
          this.naaProfileTypeNames['Id' + x.Id.toString()] = x.Name;
        });
      });
    }

    this.showRelatedProfileSummary =
      this.searchParams.RelatedProfileOptions.MainContact ||
      this.searchParams.RelatedProfileOptions.PrimaryRelationship ||
      this.searchParams.RelatedProfileOptions.ReceivesCommunication ||
      this.searchParams.RelatedProfileOptions.ResultBehavior > 0 ||
      (this.searchParams.RelatedProfileOptions.RelatedAs > 0 && this.searchParams.RelatedProfileOptions.UseRelatedAs);

    if (!this.searchParams.ExcludeAffCodes) this.searchParams.ExcludeAffCodes = [];

    this.hiddenAffCodeCount =
      Math.max(this.searchParams.AffCodes.length - 2, 0) + Math.max(this.searchParams.ExcludeAffCodes.length - 2, 0);
    this.affCodeTooltip =
      (this.searchParams.MatchAllAffCodes ? 'Must have ALL' : 'Must have ONE') +
      ': ' +
      this.searchParams.AffCodes.join(', ') +
      '\r\n' +
      (this.searchParams.MatchAllExcludeAffCodes ? 'Must NOT have ALL' : 'Must have NONE') +
      ': ' +
      this.searchParams.ExcludeAffCodes.join(', ');
  }

  public toggleAffCodeSliceEnd() {
    this.allAffCodeVisible = !this.allAffCodeVisible;
  }

  public toggleMemberTypeSliceEnd() {
    this.allMemberTypeVisible = !this.allMemberTypeVisible;
  }

  public toggleBusinessActvitiesSliceEnd() {
    this.allBusinessActvitiesVisible = !this.allBusinessActvitiesVisible;
  }

  public toggleNaaProfileTypesSliceEnd() {
    this.allNaaProfileTypesVisible = !this.allNaaProfileTypesVisible;
  }
}
